module.exports = function getResource(label, vars = []) {
    let resources = {
        multiLocation: 'Plusieurs autres heures et emplacements',
        otherLocations: `${vars[0]} autres emplacements`,
        virtual: 'Services virtuels'
    };

    return resources[label];
};
